import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import Icon from '~/components/atom/Icon';

export type StatusLabelProps = {
  status: 'active' | 'inactive' | 'warning';
  label: string;
};

const StatusLabel = ({ status, label }: StatusLabelProps) => {
  const icon =
    status === 'warning'
      ? 'exclamation'
      : status === 'inactive'
        ? 'x-circle'
        : 'check-circle';
  const color =
    status === 'warning'
      ? 'warning'
      : status === 'inactive'
        ? 'tertiary'
        : 'success';

  return (
    <JustificationContainer align="center" gap="xxs">
      <Icon name={icon} color={{ group: color, variant: 'dark' }} />
      <Body
        size="base"
        color={{ group: color, variant: 'dark' }}
        margin={[null]}
      >
        {label}
      </Body>
    </JustificationContainer>
  );
};

export default StatusLabel;
